import '../App.css';
import img_tablet from '../tablet.png';
import { useEffect, useState } from 'react';
import { getDevice } from '../QueryDevice';
import { useNavigate } from 'react-router-dom';

function CampaignStatsTopDevicesItem({
    device_id,
    impressions_count,
}) {
    const navigate = useNavigate();
    const [device, setDevice] = useState(null);

    useEffect(
        () => {
            if (!device_id) {
                return;
            }

            getDevice(device_id).then(
                (response) => setDevice(response.data)
            ).catch(
                (error) => navigate('/')
            )
        },
        [],
    )

    if (!device) {
        return null;
    }

    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                margin: '1em',
            }}>
            <div>
                <img src={img_tablet} width='80em' />
            </div>
            <div style={{ marginLeft: '1em' }}>
                <div>
                    <b>
                        {device.title}
                    </b>
                </div>
                <div>
                    {impressions_count ?? 0} impressions
                </div>
            </div>
        </div>
    );
}

export default CampaignStatsTopDevicesItem;